import React, { useEffect, useState } from 'react'
import { useParams, Link, useNavigate } from 'react-router-dom'
import { LoadIndicator } from 'devextreme-react/load-indicator'
import axios from 'axios'
import { useFavorites } from '../../hooks/useFavorites'
import FavoriteButton from '../../components/favorite-button/FavoriteButton'
import FrequentForms from '../../components/frequent-forms/FrequentForms'
import Favorites from '../../components/favorites/Favorites'

interface NavigationItem {
	model: string
	text: string
	desc?: string
	filter?: string
	dashboard?: boolean
}

export default function View() {
	const routeParams = useParams()
	const folder = routeParams['*']
	const navigate = useNavigate()
	const [navigationItems, setNavigationItems] = useState<NavigationItem[]>([])
	const { checkAllFavoritesStatus, toggleFavorite, isFavorite } = useFavorites(folder || '')

	useEffect(() => {
		if (folder) {
			setNavigationItems([])
			document.title = `Fiber`
			axios
				.get(`${API_FIBER_URL}/views?folder=${folder}`)
				.then(response => response.data)
				.then(async data => {
					if (data.models.length > 0) {
						setNavigationItems(data.models)
						document.title = `Fiber :: ${folder}`
						await checkAllFavoritesStatus(data.models)
					} else {
						navigate('/')
					}
				})
		} else {
			navigate('/')
		}
	}, [folder, navigate, checkAllFavoritesStatus])

	const breadcrumb = (folders: any) => {
		const folderArray = folders.split('/')
		let path = '' // Initialize an empty path
		return folderArray.map((folder: string, index: number) => {
			path += `/${folder}` // Append current folder and a slash to the path

			// Check if it's the last element
			if (index === folderArray.length - 1) {
				// For the last element, just return the folder name without a link
				return <span key={index}>{folder}</span>
			} else {
				// For all other elements, return them with a Link and a trailing slash
				return (
					<React.Fragment key={index}>
						<Link className="link" key={index} to={`/v${path}`}>
							{folder}
						</Link>{' '}
						/{' '}
					</React.Fragment>
				)
			}
		})
	}

	const ButtonClick = ({ item, children }: { item: NavigationItem; children?: React.ReactNode }) => {
		const { model, dashboard, filter } = item
		let urlModel = dashboard ? '/dashboard' : '/m'
		urlModel = `${urlModel}?folder=${folder}&model=${model}`
		if (filter) {
			urlModel = `${urlModel}&filter=${filter}`
		}

		return (
			<Link className="modelCard" to={urlModel} style={{ position: 'relative' }}>
				{children}
				<FavoriteButton item={item} isFavorite={isFavorite(model)} onToggle={toggleFavorite} />
			</Link>
		)
	}

	function Buttons() {
		return (
			<div className={'content-block gridView'}>
				{navigationItems.map((item: NavigationItem) => (
					<ButtonClick key={item.model} item={item}>
						<div className={'textWrapper'}>
							<p style={{ fontSize: '18px', marginBottom: '0' }}>{item.text}</p>
							{item.desc && <p style={{ marginTop: '2px' }}>{item.desc}</p>}
						</div>
					</ButtonClick>
				))}
			</div>
		)
	}

	if (navigationItems.length === 0 && folder) {
		return (
			<h2 className={'content-block'}>
				<LoadIndicator height={20} width={20} />
			</h2>
		)
	}

	if (!folder) {
		return (
			<React.Fragment>
				<h2 className={'content-block'}>Welcome to Fiber</h2>
				<div className={'wrapper-favorites-frequent'}>
					<Favorites />
					<FrequentForms />
				</div>
			</React.Fragment>
		)
	}

	return (
		<React.Fragment>
			<h2 className={'content-block'}>{breadcrumb(folder)}</h2>
			{navigationItems.length > 0 && <Buttons />}
		</React.Fragment>
	)
}
